var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'form-group--error':
      typeof _vm.validate !== 'undefined' &&
      _vm.validate.$dirty &&
      !_vm.validate.$pending &&
      _vm.validate.$invalid,
    'form-group': _vm.hasGroup,
  }},[(_vm.labelShown)?_c('label',{attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.isRequired)?_c('span',{staticClass:"text-danger"},[_vm._v(" * ")]):_vm._e()]):_vm._e(),_c('div',[_c('InputMask',{class:[
        {
          'p-invalid':
            typeof _vm.validate !== 'undefined' &&
            _vm.validate.$dirty &&
            !_vm.validate.$pending &&
            _vm.validate.$invalid,
        },
        _vm.inputClass,
        'form-control',
      ],attrs:{"id":_vm.id,"mask":_vm.mask,"slotChar":_vm.slotChar,"autoClear":_vm.autoClear,"unmask":_vm.unmask,"readonly":_vm.readonly,"disabled":_vm.disabled,"placeholder":_vm.placeholder},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1),(typeof _vm.validate !== 'undefined')?_c('BaseFormMessage',{attrs:{"validate":_vm.validate,"label":_vm.label}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }